/**
 * MentorLiveRoomScreen.web.jsx
 *
 * Web platform stub for the LiveKit mentor room screen.
 * The native @livekit/react-native SDK is not compatible with the web bundler
 * due to its dependency on native WebRTC and React Native internals.
 *
 * This file is automatically picked by Metro and Webpack over MentorLiveRoomScreen.jsx
 * when building for the web platform.
 */

import React from 'react';
import {
    View, Text, StyleSheet, TouchableOpacity, StatusBar,
    Dimensions, Linking
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useNavigation, useRoute } from '@react-navigation/native';

const { width } = Dimensions.get('window');

const MentorLiveRoomScreen = () => {
    const navigation = useNavigation();
    const route = useRoute();
    const { topic = 'Live Session', mentorName = 'Mentor' } = route.params || {};

    return (
        <View style={styles.container}>
            <StatusBar barStyle="light-content" backgroundColor="#0a0010" />

            <View style={styles.header}>
                <TouchableOpacity style={styles.backBtn} onPress={() => navigation.goBack()}>
                    <Ionicons name="arrow-back" size={22} color="#fff" />
                </TouchableOpacity>
                <Text style={styles.headerTitle} numberOfLines={1}>{topic}</Text>
                <View style={{ width: 38 }} />
            </View>

            <View style={styles.body}>
                <View style={styles.iconWrapper}>
                    <Ionicons name="videocam-off-outline" size={72} color="#7c3aed" />
                </View>

                <Text style={styles.title}>Mobile App Required</Text>
                <Text style={styles.subtitle}>
                    Live video sessions are only supported on the{'\n'}
                    <Text style={styles.bold}>Youth Connect mobile app</Text>.
                </Text>
                <Text style={styles.mentorText}>Hosted by <Text style={styles.purple}>{mentorName}</Text></Text>

                <View style={styles.card}>
                    <Ionicons name="phone-portrait-outline" size={20} color="#a78bfa" />
                    <Text style={styles.cardText}>
                        Download the Youth Connect app to join this live mentor session with full video and audio support.
                    </Text>
                </View>

                <TouchableOpacity style={styles.primaryBtn} onPress={() => navigation.goBack()}>
                    <Ionicons name="arrow-back" size={16} color="#fff" style={{ marginRight: 8 }} />
                    <Text style={styles.primaryBtnText}>Back to Spaces</Text>
                </TouchableOpacity>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#0a0010',
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 16,
        paddingVertical: 14,
        paddingTop: 50,
        borderBottomWidth: 1,
        borderBottomColor: 'rgba(124,58,237,0.2)',
    },
    backBtn: {
        width: 38,
        height: 38,
        borderRadius: 12,
        backgroundColor: 'rgba(255,255,255,0.08)',
        alignItems: 'center',
        justifyContent: 'center',
    },
    headerTitle: {
        color: '#fff',
        fontSize: 16,
        fontWeight: '700',
        flex: 1,
        textAlign: 'center',
        marginHorizontal: 10,
    },
    body: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        padding: 30,
    },
    iconWrapper: {
        width: 130,
        height: 130,
        borderRadius: 65,
        backgroundColor: 'rgba(124,58,237,0.12)',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 28,
        borderWidth: 2,
        borderColor: 'rgba(124,58,237,0.25)',
    },
    title: {
        color: '#fff',
        fontSize: 24,
        fontWeight: '800',
        marginBottom: 14,
        textAlign: 'center',
    },
    subtitle: {
        color: 'rgba(255,255,255,0.55)',
        fontSize: 15,
        textAlign: 'center',
        lineHeight: 22,
        marginBottom: 8,
    },
    bold: {
        color: 'rgba(255,255,255,0.85)',
        fontWeight: '600',
    },
    mentorText: {
        color: 'rgba(255,255,255,0.4)',
        fontSize: 13,
        marginBottom: 28,
    },
    purple: {
        color: '#a78bfa',
        fontWeight: '700',
    },
    card: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        backgroundColor: 'rgba(124,58,237,0.1)',
        borderRadius: 16,
        padding: 18,
        gap: 12,
        maxWidth: 420,
        width: '100%',
        marginBottom: 32,
        borderWidth: 1,
        borderColor: 'rgba(124,58,237,0.2)',
    },
    cardText: {
        color: 'rgba(196,181,253,0.8)',
        fontSize: 14,
        lineHeight: 20,
        flex: 1,
    },
    primaryBtn: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#7c3aed',
        paddingHorizontal: 28,
        paddingVertical: 14,
        borderRadius: 25,
    },
    primaryBtnText: {
        color: '#fff',
        fontSize: 15,
        fontWeight: '700',
    },
});

export default MentorLiveRoomScreen;
